import React, { Component } from 'react';
import { Form } from '@ant-design/compatible';
import { Select, Button } from 'antd';
import { PropTypes } from 'prop-types';
import dayjs from 'dayjs';
import DateRangePicker from '../../../components/DateRangePicker';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

class DriverJourneyHistoryFilterForm extends Component {
    constructor(props) {
        super(props);
        let currentDriverFilters = null;
        if (props?.driverViewJourneyFilters?.length) {
            const matches = props.driverViewJourneyFilters.filter(f => parseInt(f.driverId) === parseInt(props.driverId));
            if (matches?.length) {
                currentDriverFilters = matches[0]?.filters;
            }
        }
        this.state = { currentDriverFilters };
    }

    componentDidUpdate(prevProps) {
        const { driverViewJourneyFilters, driverId } = this.props;
        
        if (prevProps.driverViewJourneyFilters !== driverViewJourneyFilters) {
            let currentDriverFilters = null;
            if (driverViewJourneyFilters?.length) {
                const matches = driverViewJourneyFilters.filter(f => parseInt(f.driverId) === parseInt(driverId));
                if (matches?.length) {
                    currentDriverFilters = matches[0]?.filters;
                }
            }
            this.setState({ currentDriverFilters });
        }
    }

    submitForm = (e) => {
        const { onSubmit, form } = this.props;
        
        e.preventDefault();
        form.validateFields((err, values) => {
            if (!err) {
                onSubmit(values);
            }
        });
    };

    render() {
        const { form, assetOptions, telematicsRetentionDays } = this.props;
        const { currentDriverFilters } = this.state;

        const { getFieldDecorator, getFieldValue } = form;

        return (
            <Form onSubmit={this.submitForm} layout="vertical">
                <Form.Item label="Assets">
                    {getFieldDecorator('assets', { initialValue: currentDriverFilters?.assets || null })(
                        <Select 
                            mode="multiple" 
                            placeholder="Select Assets"
                            showSearch
                            filterOption={(txt, obj) => (obj.props.children.toLowerCase().includes(txt.toLowerCase()))}
                            data-testid='driver-details-journey-filter_asset-select'
                        >
                            {assetOptions.map((a) => (
                                <Select.Option 
                                    key={a.id} 
                                    value={a.id}
                                >
                                    {a.name === a.reg || !a.reg ? a.name : `${a.name} [${a.reg}]`}
                                </Select.Option>
                            ))}
                        </Select>
                    )}
                </Form.Item>
                <DateRangePicker
                    getFieldDecorator={getFieldDecorator}
                    getFieldValue={getFieldValue}
                    minDate={dayjs().subtract(telematicsRetentionDays, 'days')}
                    dateFromInitialValue={dayjs(currentDriverFilters?.date_from) || dayjs()}
                    dateToInitialValue={dayjs(currentDriverFilters?.date_to) || dayjs()}
                    dataTestId='driver-details-journey-filter_date-range-picker'
                />
                <Form.Item label="Journey events">
                    {getFieldDecorator('journey_event', { initialValue: currentDriverFilters?.journey_event || 'all' })(
                        <Select 
                            placeholder="Select Journey Events"
                            data-testid='driver-details-journey-filter_events-select'
                        >
                            <Select.Option value="all">All</Select.Option>
                            <Select.Option value="1">Yes</Select.Option>
                            <Select.Option value="0">No</Select.Option>
                        </Select>
                    )}
                </Form.Item>
                <Form.Item label="Authorised">
                    {getFieldDecorator('is_authorised', { initialValue: currentDriverFilters?.is_authorised || 'all' })(
                        <Select placeholder="Select Authorised Journeys">
                            <Select.Option value="all">All</Select.Option>
                            <Select.Option value="1">Yes</Select.Option>
                            <Select.Option value="0">No</Select.Option>
                        </Select>
                    )}
                </Form.Item>
                <div className="mt-2 mb-1 text-center">
                    <Button 
                        htmlType="submit" 
                        type="primary"
                        data-testid='driver-details-journey-filter_filter-btn'
                    >
                        Filter
                    </Button>
                </div>
            </Form>
        );
    }
}

DriverJourneyHistoryFilterForm.propTypes = {
    onSubmit: PropTypes.func.isRequired,
    form: PropTypes.object.isRequired,
    assetOptions: PropTypes.array,
    telematicsRetentionDays: PropTypes.number,
    driverViewJourneyFilters: PropTypes.object,
};

DriverJourneyHistoryFilterForm.defaultProps = {
    assetOptions: [],
};

const DriverJourneyHistoryFilter = Form.create({ name: 'journey_filter_form' })(DriverJourneyHistoryFilterForm);

function mapStateToProps(state, ownProps) {
    return {
        ...ownProps,
        assetOptions: state.asset.assetList,
        telematicsRetentionDays: state.user.userCompany.telematics_retention_days,
        driverViewJourneyFilters: state.driver.driverViewJourneyFilters,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators({
        }, dispatch),
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(DriverJourneyHistoryFilter);
